<template>
	<div class="teacher-login">

		<!-- ====================== 步骤1：输入账号密码 ====================== -->
		<div v-if="!showUserSelect">
			<div class="tab">
				<span @click="loginTyp = 'account'" :class="loginTyp == 'account' ? 'on' : ''">账号</span>
				<span @click="loginTyp = 'phone'" :class="loginTyp == 'phone' ? 'on' : ''">手机号</span>
				<span @click="loginTyp = 'code'" :class="loginTyp == 'code' ? 'on' : ''">二维码</span>

			</div>

			<div v-if="loginTyp == 'account'">
				<input class="input" placeholder="教师账号" v-model="form.username" @keyup.enter="logins" />
				<input class="input" placeholder="密码" type="password" v-model="form.password" @keyup.enter="logins" />
				<button class="btn" @click="logins">登录</button>
			</div>

			<div v-if="loginTyp == 'phone'">
				<input class="input" placeholder="手机号" v-model="form.username" @keyup.enter="logins" />
				<input class="input" placeholder="密码" type="password" v-model="form.password" @keyup.enter="logins" />
				<button class="btn" @click="logins">登录</button>
			</div>
			<div v-if="loginTyp == 'code'">
				<button @click="uploadImg" class="upload-btn" style="margin-top: 10px;">上传二维码图片</button>
				<input ref="file" type="file" accept="image/png,image/jpg,image/jpeg" style="display:none"
					@change="doUpload" />
				<div class="tip">{{ msg }}</div>
			</div>
		</div>

		<!-- ====================== 步骤2：钉钉风格 选择用户（无弹窗、同页面切换） ====================== -->
		<div v-else class="select-user-wrapper">
			<!-- 返回 -->
			<div class="back-btn" @click="backToLogin">
				<i class="el-icon-arrow-left"></i> 返回登录
			</div>

			<!-- 标题 -->
			<div class="title">请选择登录身份</div>

			<!-- 用户列表 -->
			<div class="user-list">
				<div class="user-item" v-for="item in userList" :key="item.id" @click="confirmSelectUser(item)">
					<div class="avatar">{{ item.nickName.substring(0,1) }}</div>
					<div class="info">
						<div class="name">{{ item.nickName }}</div>
						<div class="org">{{ item.orgName || '学校用户' }}</div>
					</div>
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginType,
		userInfo,
		loginTeacher,
		logUserText
	} from '../login.js'
	import jsQR from 'jsqr'
	export default {
		props: {
			qrToken: {
				type: String,
				default: ''
			}
		},
		watch: {
			qrToken: {
				handler(newVal) {
					console.log('✅ 子组件收到扫码token：', newVal)
					if (newVal) {
						this.qrLogin(newVal)
					}
				},
				immediate: true
			}
		},
		data() {
			return {
				loginTyp: "account",
				form: {
					username: "",
					password: ""
				},
				login: null,
				tempKey: '',

				// 多用户选择
				showUserSelect: false, // 控制显示：输入框 / 用户选择
				userList: [],
				userId: '',
				msg: '',
			};
		},
		methods: {
			uploadImg() {
				if (this.$refs.file) {
					this.$refs.file.value = ''
					this.msg = ''
					this.$refs.file.click()
				}
			},
			doUpload(e) {
				const file = e.target.files[0]
				if (!file) return
				const validTypes = ['image/png', 'image/jpg', 'image/jpeg']
				if (!validTypes.includes(file.type)) {
					this.$message.error('请上传PNG/JPG/JPEG格式的图片')
					return;
				}
				const reader = new FileReader()
				const that = this
				reader.onload = function(e) {
					const img = new Image()
					img.onload = function() {
						try {
							const canvas = document.createElement('canvas')
							const ctx = canvas.getContext('2d')
							canvas.width = img.width
							canvas.height = img.height
							ctx.drawImage(img, 0, 0)
							const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
							const code = jsQR(imageData.data, imageData.width, imageData.height)
							if (code) {
								that.msg = '上传识别成功'
								that.handleQrCodeData(code.data)
							} else {
								that.msg = '未识别到二维码内容'
							}
						} catch (innerErr) {
							that.$message.error('二维码解析失败')
							that.msg = '解析失败'
						}
					}
					img.src = e.target.result
				}
				reader.readAsDataURL(file)
			},
			handleQrCodeData(qrData) {
				try {
					let loginToken = qrData
					const queryIndex = qrData.indexOf('?')
					if (queryIndex > -1) {
						const queryStr = qrData.slice(queryIndex + 1)
						const params = new URLSearchParams(queryStr)
						loginToken = params.get('data') || qrData
					}
					this.callLoginByToken(loginToken)
				} catch (err) {
					this.showMask = false
					this.$message.error('解析失败')
				}
			},
			async callLoginByToken(loginToken) {
				if (!loginToken) return
				let list = loginToken.indexOf('|') > -1 ? loginToken.split('|') : [loginToken, '']
				if (list.length < 2) list[1] = ''
				if (localStorage.getItem('token')) {
					localStorage.removeItem('token')
				}
				try {
					const res = await this.API.post(this.API.fileurl.postLoginQr, {
						qrCode: list[0].trim(),
						sign: list[1].trim()
					})

					if (res.data.code == 200) {
						logUserText(res)

						console.log('rrr', res)
						if (res.data.data.userType == 3) {

							this.$nextTick(() => {
								this.noLogin()
								this.$message.success('免登成功！')
								this.$router.push('/student/home')
							})
						} else {
							await userInfo()
							this.$nextTick(() => {
								this.noLogin()
								localStorage.setItem('isPptXml',false)
								this.$message.success('免登成功！')
								this.$router.push('/teacher')
							})
						}

					} else {
						this.noLogin()
						this.$message.error('免登失败：' + (res.data.msg || res.msg))
					}
				} catch (err) {
					this.noLogin()
					this.$message.error('免登接口失败')
				} finally {

				}
			},
			resetPid() {
				if (localStorage.getItem("PID")) {
					localStorage.removeItem("PID")
				}
			},
			async qrLogin(token) {
				try {
					// 👇 你的后端扫码登录接口
					const loginT = await loginTeacher(this.API, token)

					if (loginT == 'true') {
						let userinfo = await userInfo(this.API)
						if (userinfo == 'true') {
							localStorage.setItem("PID", true)
							this.$message.success('登录成功')
							this.noLogin()
							this.$router.push('/teacher')
						} else {
							this.noLogin()
							this.resetPid()
						}
					}

				} catch (e) {
					this.resetPid()
					this.$message.error('登录失败')
				}
			},
			// 返回登录页
			backToLogin() {
				this.showUserSelect = false
				this.userId = ''
				this.userList = []
				this.tempKey = ''
			},

			// 登录
			async logins() {
				if (!this.form.username || !this.form.password) {
					this.$message.warning("请输入账号密码");
					return;
				}
				if (this.login) return;

				this.loginOpen('登录中...')
				let isPhoneLogin = this.loginTyp == 'phone' ? 1 : 0
				let loginT = await loginType(
					this.API,
					this.form.username,
					this.form.password,
					2,
					isPhoneLogin,
					this.tempKey,
					this.userId
				)

				if (loginT == 'true') {
					let userinfo = await userInfo(this.API)
					if (userinfo == 'true') {
						localStorage.setItem('isPptXml',false)
						this.$message.success('登录成功')
						this.noLogin()
						this.$router.push('/teacher')
					} else {
						this.noLogin()
					}
				}

				// 需要选择用户 → 切换到钉钉选择界面
				else if (loginT.tempKey) {
					this.userList = loginT.userList
					this.tempKey = loginT.tempKey
					this.showUserSelect = true // 显示用户选择
					this.noLogin()
				} else {
					this.noLogin()
					this.$message.error(loginT)
				}
			},

			// 选择用户 → 直接登录
			async confirmSelectUser(user) {
				this.userId = user.id
				this.loginOpen('登录中...')

				let loginT = await loginType(
					this.API,
					'',
					'',
					2,
					'',
					this.tempKey,
					this.userId
				)

				if (loginT == 'true') {
					let userinfo = await userInfo(this.API)
					if (userinfo == 'true') {
						localStorage.setItem('isPptXml',false)
						this.$message.success('登录成功')
						this.noLogin()
						this.$router.push('/teacher')
					}
				} else {
					this.noLogin()
					this.$message.error('登录失败')
				}
			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
		},
	};
</script>

<style scoped>
	.teacher-login {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	/* 顶部TAB */
	.tab {
		display: flex;
		margin-bottom: 15px;
	}

	.tab span {
		flex: 1;
		text-align: center;
		padding: 6px;
		cursor: pointer;
		font-size: 16px;
	}

	.tab span.on {
		color: #2d8cf0;
		font-weight: bold;
	}

	/* 输入框 */
	.input {
		width: 100%;
		height: 44px;
		margin-bottom: 10px;
		padding: 0 12px;
		border: 1px solid #ddd;
		border-radius: 6px;
		box-sizing: border-box;
		outline: none;
		font-size: 14px;
	}

	.input:focus {
		border-color: #2d8cf0;
	}

	/* 按钮 */
	.btn {
		width: 100%;
		height: 44px;
		background: #2d8cf0;
		color: #fff;
		border: none;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;
	}

	/* ====================== 钉钉风格 选择用户 ====================== */
	.select-user-wrapper {
		width: 100%;
	}

	.back-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		color: #2d8cf0;
		margin-bottom: 16px;
		cursor: pointer;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
		text-align: center;
	}

	/* 用户列表 */
	.user-list {
		width: 100%;
	}

	.user-item {
		display: flex;
		align-items: center;
		padding: 14px 12px;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
	}

	.user-item:active {
		background: #f5f5f5;
	}

	/* 头像 */
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: #2d8cf0;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: bold;
		margin-right: 12px;
	}

	/* 信息 */
	.info {
		flex: 1;
	}

	.info .name {
		font-size: 15px;
		font-weight: 500;
		color: #333;
		margin-bottom: 4px;
	}

	.info .org {
		font-size: 13px;
		color: #999;
	}

	/* 箭头 */
	.el-icon-arrow-right {
		color: #ccc;
		font-size: 16px;
	}
</style>